<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'PerbedaanTakafuldenganKonvensional',

    metaInfo: { title: 'Perbedaan Takaful dengan Konvensional' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'different',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'different',
      },
    },
  }
</script>
